import axios from 'axios'
import {config} from '@/core/config/base'
import {storageLocal} from '@/core/libs/storage'
export const setBearer = () => {
  return new Promise(resolve => {
    storageLocal.get([config.jwt])
      .then(
        response => {
          resolve('Bearer ' + response[0])
        }
      )
      .catch(
        () => {
          resolve(null)
        }
      )
  })
}
export const http = () => {
  return new Promise(resolve => {
    setBearer()
      .then(
        bearer => {
          let http = axios.create({
            baseURL: config.api.url,
            headers: {
              'Authorization': bearer,
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            }
          })
          resolve(http)
        }
      )
  })
}



// WEBPACK FOOTER //
// ./src/core/api/headers.js